import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  makeStyles,
  TextField,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useState } from "react";
import useForgotPassword from "../hooks/useForgotPassword";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: 667,
    overflow: "hidden",
    margin: "0 auto",
    paddingTop: 50,
    root: {
      overflow: "hidden",
    },
  },
  helperText: {
    color: theme.red,
  },
  title: {
    fontSize: 30,
    color: theme.orange,
  },
  content: {
    fontSize: 16,
    color: theme.black,
  },
  paper: {
    margin: 0,
    width: 667,
    maxWidth: 667,
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
    alignItems: "center",
    overflow: "hidden",
  },

  dialogAction: { padding: 0 },
  button: { fontSize: 24, borderRadius: 0, marginTop: 10 },
}));
const ENTER_USER = 0;
const ENTER_OTP = 1;
const ENTER_OTP_WRONG = 4;
const SUCCESS = 2;
const ERROR = -1;
const NEW_PASSWORD = 3;
const ResetPasswordDialog = ({ open, onClose }) => {
  const classes = useStyles();
  const { forgotPassword, addNewPassword, submitOTP } = useForgotPassword();
  const [username, setUsername] = useState();
  const [maskedEmail, setMaskedEmail] = useState();

  const [otp, setOTP] = useState();
  const [newPassword, setNewPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [refCode, setRefCode] = useState();
  const [dialogState, setDialogState] = useState(ENTER_USER);
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={open}
      className={classes.allContainer}
      onClose={onClose}
    >
      <DialogTitle id="customized-dialog-title">
        <Typography align="center" classes={{ root: classes.title }}>
          {dialogState === ENTER_USER
            ? "Forgot Password ?"
            : dialogState === ENTER_OTP || dialogState === ENTER_OTP_WRONG
            ? "OTP"
            : dialogState === SUCCESS
            ? "Success !"
            : dialogState === NEW_PASSWORD
            ? "Change Password"
            : "Error"}
        </Typography>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <Typography align="center" classes={{ root: classes.content }}>
          {dialogState === ENTER_USER
            ? "Enter your username below and we'll get you back on track."
            : dialogState === ENTER_OTP
            ? "Enter your otp received via email (" + maskedEmail + ")"
            : dialogState === ENTER_OTP_WRONG
            ? "Enter your otp received via email (" + maskedEmail + ")"
            : dialogState === SUCCESS
            ? "Success"
            : dialogState === NEW_PASSWORD
            ? ""
            : "Something went wrong, please try again later."}
        </Typography>
        {dialogState === ENTER_USER && (
          <TextField onChange={(e) => setUsername(e.target.value)} />
        )}
        {(dialogState === ENTER_OTP || dialogState === ENTER_OTP_WRONG) && (
          <TextField
            onChange={(e) => setOTP(e.target.value)}
            helperText={
              dialogState === ENTER_OTP_WRONG ? "Wrong otp, try again" : null
            }
            FormHelperTextProps={{
              className: classes.helperText,
            }}
          />
        )}
        {dialogState === NEW_PASSWORD && (
          <>
            <TextField
              type={showPassword ? "text" : "password"}
              label="Password"
              onChange={(e) => setNewPassword(e.target.value)}
              helperText={
                newPassword &&
                newPassword.length <= 8 &&
                "Should more than 8 characters"
              }
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Pass"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              type={showConfirmPassword ? "text" : "password"}
              label="Confirm Password"
              style={{ marginTop: 10 }}
              onChange={(e) => setConfirmPassword(e.target.value)}
              helperText={
                confirmPassword &&
                newPassword !== confirmPassword &&
                "Password doesn't match"
              }
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Confirm"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </>
        )}
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <Button
          disabled={buttonDisabled(
            dialogState,
            username,
            otp,
            newPassword,
            confirmPassword
          )}
          onClick={async () => {
            if (dialogState === ENTER_USER) {
              const [result, error] = await forgotPassword(username);
              if (result) {
                setMaskedEmail(result.payload.target);
                setRefCode(result.payload.ref_code);
                return setDialogState(ENTER_OTP);
              }
              if (error) {
                return setDialogState(ERROR);
              }
              return setDialogState(ERROR);
            } else if (dialogState === ERROR) {
              onClose();
              setDialogState(ENTER_USER);
            } else if (dialogState === ENTER_OTP) {
              const [, error] = await submitOTP(username, refCode, otp);
              if (error) setDialogState(ENTER_OTP_WRONG);
              else return setDialogState(NEW_PASSWORD);
            } else if (dialogState === ENTER_OTP_WRONG) {
              const [, error] = await submitOTP(username, refCode, otp);
              if (error) setDialogState(ERROR);
              else return setDialogState(NEW_PASSWORD);
            } else if (dialogState === NEW_PASSWORD) {
              const [result, error] = await addNewPassword(
                username,
                newPassword,
                refCode
              );
              if (result) return setDialogState(SUCCESS);
              if (error) return setDialogState(ERROR);
              return setDialogState(ERROR);
            } else if (dialogState === SUCCESS) {
              onClose();
            }
          }}
          color="primary"
          fullWidth
          variant="contained"
          classes={{ contained: classes.button }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const buttonDisabled = (
  dialogState,
  username,
  otp,
  newPassword,
  confirmPassword
) => {
  if (dialogState === NEW_PASSWORD) {
    if (!newPassword || !confirmPassword) return true;
    if (newPassword !== confirmPassword) return true;
    if (newPassword.length <= 8) return true;
    return false;
  }

  if (dialogState === ENTER_USER) {
    if (!username) return true;

    return false;
  }

  if (dialogState === ENTER_OTP) {
    if (!otp) return true;

    return false;
  }

  if (dialogState === ENTER_OTP) {
    return false;
  }

  return false;
};

export default ResetPasswordDialog;
